import { module } from 'modujs';
import gsap from "gsap";
import { debounce } from '../utils/tickers';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (this.el.querySelectorAll('[data-collapse]')) {
            this.el.querySelectorAll('[data-collapse]').forEach((collapse) => {
                let collapseToggle = collapse.querySelector('[data-collapse-toggle]');
                let collapseContent = collapse.querySelector('[data-collapse-content]');
                collapseToggle.addEventListener('click', (e) => {
                    let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                    collapse.toggleAttribute('data-collapse-opened');
                    gsap.to(collapseContent, {
                        height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                        ease: 'expo.out',
                        duration: 0.8,
                        onComplete: () => { 
                            this.call('resize', 'Scroll');
                        }
                    });
                })
            })
        }

        window.addEventListener(
            "resize",
            debounce(() => {
                this.resizeCollapsesContents()
            }, 10, false)
        );
    }

    resizeCollapsesContents() {
        if (this.el.querySelectorAll('[data-collapse-opened]')) {
            this.el.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
                let contentHeight = collapse.querySelector('[data-collapse-content-inner]').offsetHeight;
                collapse.querySelector('[data-collapse-content]').style.height = contentHeight + 'px';
            });
        }
    };
}
